// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"38ddc368","787":"449cfa79","874":"a0fd1e82","904":"eca4f824"}[chunkId] + ".chunk.js";
};